import Forbidden from "@Pages/Error/Forbidden";
import { Suspense, lazy, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@Reducers/index";

const Workflows = lazy(() => import("../../../../components/SpaceSettings/UserAdministration/Workflows/Workflows"));
const WorkflowDetails = lazy(
  () => import("../../../../components/SpaceSettings/UserAdministration/Workflows/WorkflowDetails"),
);

interface WorkflowsWrapperProps {
  projectId: string;
}

function WorkflowsWrapper({ projectId }: WorkflowsWrapperProps) {
  const [reviewFlowId, setWorkflowId] = useState("");
  const getProjectSettingObject = useSelector((state: RootState) => state.getProjectSettingObject);

  // Derived directly from the permission object — no need for state + effect.
  const hasAccess = Boolean(getProjectSettingObject?.reviewFlow?.add?.enable);

  const handleWorkflowChange = (id: string) => {
    setWorkflowId(id);
  };

  return (
    <>
      {!reviewFlowId ? (
        <Suspense>
          {hasAccess ? <Workflows handleWorkflowChange={handleWorkflowChange} projectId={projectId} /> : <Forbidden />}
        </Suspense>
      ) : (
        <Suspense>
          <WorkflowDetails
            handleWorkflowChange={handleWorkflowChange}
            reviewFlowId={reviewFlowId}
            projectId={projectId}
          />
        </Suspense>
      )}
    </>
  );
}

export default WorkflowsWrapper;
